// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Payroll_ExpenseConciliationCompleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for expense_conciliation_complete /payroll/expense_conciliation_complete
 * Returns the completion status with amount, count, and status label
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Payroll_ExpenseConciliationCompleteResponseDados {
status: number
status_label: string
amount: number
count: number
}

export type Payroll_ExpenseConciliationCompleteResponse = ApiResponse<Payroll_ExpenseConciliationCompleteResponseDados>;

registerResponseContract('Payroll_ExpenseConciliationCompleteResponse', {
  status:       { type: 'number',  required: true },
  status_label: { type: 'string',  required: true },
  amount:       { type: 'number',  required: true },
  count:        { type: 'number',  required: true },
})
